<template>
  <div>
    <span v-if="records">
      {{count}} {{count === 1 ? name : `${name}s`}}
    </span>
    <span v-else>-</span>
  </div>
</template>

<script>
export default {
  name: 'RecordCount',
  props: {
    records: Array,
    name: String,
  },
  computed: {
    count() {
      return this.records && this.records.length;
    },
  },
};
</script>
